import { toast } from 'react-toastify';
import useUserStore from '../../Stores/UserStore';
import { translateText } from '../../Services/GoogleTranslate';

export const TOAST_Z_INDEX = 200000;

export function showToast(message, type = 'error') {
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  } else if (type === 'info') {
    toast.info(message);
  } else {
    toast(message);
  }
}

export function showModerationToast(message) {
  if (!message) return;

  toast.error(String(message), {
    autoClose: 6000,
    toastId: 'content-moderation-blocked',
  });
}

export async function showTranslatedToast(baseMessage, type = 'success') {
  const target = useUserStore.getState().appLanguage ?? 'en';
  const message = await translateText(baseMessage, target);
  showToast(message, type);
}
